export const faceSwapeRoleOptions = {
    gender: {
      label: '性別',
      options: {
        man: '男性',
        woman: '女性'
      }
    },
    age: {
      label: '年齡',
      options: {
        baby: '嬰兒 (0-2歲)',
        child: '兒童 (3-12歲)',
        teenager: '青少年 (13-19歲)',
        youngAdult: '青年 (20-39歲)',
        middleAged: '中年 (40-59歲)',
        senior: '老年 (60歲以上)'
      }
    },
    expression: {
      label: '表情',
      options: {
        happy: '開心',
        laughing: '大笑',
        serious: '嚴肅',
        calm: '平靜',
        surprised: '驚訝',
        sad: '悲傷',
        angry: '憤怒',
        thoughtful: '沉思'
      }
    },
    eyeColor: {
      label: '眼睛顏色',
      options: {
        black: '黑色',
        brown: '棕色',
        blue: '藍色',
        green: '綠色',
        gray: '灰色',
        hazel: '淡褐色'
      }
    },
    hairStyle: {
      label: '髮型',
      options: {
        buzzCut: '寸頭',
        crewCut: '平頭',
        pixieCut: '精靈短髮',
        bobCut: '波波頭',
        shoulderLength: '齊肩髮',
        longStraight: '長直髮',
        longWavy: '長捲髮',
        curly: '捲髮',
        afro: '爆炸頭',
        ponytail: '馬尾',
        highBun: '高髮髻',
        lowBun: '低髮髻',
        bald: '光頭'
      }
    },
    hairColor: {
      label: '髮色',
      options: {
        black: '黑色',
        darkBrown: '深棕色',
        lightBrown: '淺棕色',
        blonde: '金色',
        platinumBlonde: '鉑金色',
        red: '紅色',
        auburn: '赤褐色',
        gray: '灰色',
        white: '白色',
        colorful: '彩色'
      }
    },
    beard: {
      label: '鬍鬚',
      options: {
        cleanShaven: '乾淨剃鬚',
        fiveOClockShadow: '淡鬍渣',
        lightStubble: '輕鬍渣',
        heavyStubble: '重鬍渣',
        goatee: '山羊鬍',
        vanDyke: '范戴克鬍',
        fullBeard: '絡腮鬍',
        handlebarMustache: '八字鬍',
        pencilMustache: '鉛筆鬍'
      }
    },
    nationality: {
      label: '國籍',
      options: {
        afghan: '阿富汗人',
        albanian: '阿爾巴尼亞人',
        algerian: '阿爾及利亞人',
        american: '美國人',
        andorran: '安道爾人',
        angolan: '安哥拉人',
        argentine: '阿根廷人',
        armenian: '亞美尼亞人',
        australian: '澳洲人',
        austrian: '奧地利人',
        azerbaijani: '亞塞拜然人',
        bahamian: '巴哈馬人',
        bahraini: '巴林人',
        bangladeshi: '孟加拉人',
        barbadian: '巴貝多人',
        belarusian: '白俄羅斯人',
        belgian: '比利時人',
        belizean: '貝里斯人',
        beninese: '貝南人',
        bhutanese: '不丹人',
        bolivian: '玻利維亞人',
        brazilian: '巴西人',
        british: '英國人',
        bruneian: '汶萊人',
        bulgarian: '保加利亞人',
        burkinabe: '布吉納法索人',
        burundian: '蒲隆地人',
        cambodian: '柬埔寨人',
        cameroonian: '喀麥隆人',
        canadian: '加拿大人',
        capeVerdian: '維德角人',
        chadian: '查德人',
        chilean: '智利人',
        chinese: '中國人',
        colombian: '哥倫比亞人',
        congolese: '剛果人',
        costaRican: '哥斯大黎加人',
        croatian: '克羅埃西亞人',
        cuban: '古巴人',
        cypriot: '賽普勒斯人',
        czech: '捷克人',
        danish: '丹麥人',
        dominican: '多明尼加人',
        dutch: '荷蘭人',
        ecuadorean: '厄瓜多人',
        egyptian: '埃及人',
        emirian: '阿聯酋人',
        estonian: '愛沙尼亞人',
        ethiopian: '衣索比亞人',
        fijian: '斐濟人',
        filipino: '菲律賓人',
        finnish: '芬蘭人',
        french: '法國人',
        gabonese: '加彭人',
        gambian: '甘比亞人',
        georgian: '喬治亞人',
        german: '德國人',
        ghanaian: '迦納人',
        greek: '希臘人',
        guatemalan: '瓜地馬拉人',
        guinean: '幾內亞人',
        haitian: '海地人',
        honduran: '宏都拉斯人',
        hungarian: '匈牙利人',
        icelander: '冰島人',
        indian: '印度人',
        indonesian: '印尼人',
        iranian: '伊朗人',
        iraqi: '伊拉克人',
        irish: '愛爾蘭人',
        israeli: '以色列人',
        italian: '義大利人',
        ivorian: '象牙海岸人',
        jamaican: '牙買加人',
        japanese: '日本人',
        jordanian: '約旦人',
        kazakhstani: '哈薩克人',
        kenyan: '肯亞人',
        northKorean: '北韓人',
        southKorean: '南韓人',
        kuwaiti: '科威特人',
        kyrgyz: '吉爾吉斯人',
        laotian: '寮國人',
        latvian: '拉脫維亞人',
        lebanese: '黎巴嫩人',
        liberian: '賴比瑞亞人',
        libyan: '利比亞人',
        lithuanian: '立陶宛人',
        luxembourgish: '盧森堡人',
        macedonian: '馬其頓人',
        malagasy: '馬達加斯加人',
        malawian: '馬拉威人',
        malaysian: '馬來西亞人',
        maldivan: '馬爾地夫人',
        malian: '馬利人',
        maltese: '馬爾他人',
        mauritanian: '茅利塔尼亞人',
        mauritian: '模里西斯人',
        mexican: '墨西哥人',
        moldovan: '摩爾多瓦人',
        mongolian: '蒙古人',
        montenegrin: '蒙特內哥羅人',
        moroccan: '摩洛哥人',
        mozambican: '莫三比克人',
        namibian: '納米比亞人',
        nepalese: '尼泊爾人',
        newZealander: '紐西蘭人',
        nicaraguan: '尼加拉瓜人',
        nigerian: '奈及利亞人',
        norwegian: '挪威人',
        pakistani: '巴基斯坦人',
        panamanian: '巴拿馬人',
        paraguayan: '巴拉圭人',
        peruvian: '秘魯人',
        polish: '波蘭人',
        portuguese: '葡萄牙人',
        qatari: '卡達人',
        romanian: '羅馬尼亞人',
        russian: '俄羅斯人',
        rwandan: '盧安達人',
        salvadoran: '薩爾瓦多人',
        saudi: '沙烏地阿拉伯人',
        scottish: '蘇格蘭人',
        senegalese: '塞內加爾人',
        serbian: '塞爾維亞人',
        singaporean: '新加坡人',
        slovakian: '斯洛伐克人',
        slovenian: '斯洛維尼亞人',
        somali: '索馬利亞人',
        southAfrican: '南非人',
        spanish: '西班牙人',
        sriLankan: '斯里蘭卡人',
        sudanese: '蘇丹人',
        swedish: '瑞典人',
        swiss: '瑞士人',
        syrian: '敘利亞人',
        thai: '泰國人',
        togolese: '多哥人',
        tunisian: '突尼西亞人',
        turkish: '土耳其人',
        ugandan: '烏干達人',
        ukrainian: '烏克蘭人',
        uruguayan: '烏拉圭人',
        uzbekistani: '烏茲別克人',
        venezuelan: '委內瑞拉人',
        vietnamese: '越南人',
        welsh: '威爾斯人',
        yemeni: '葉門人',
        zambian: '尚比亞人',
        zimbabwean: '辛巴威人'
      }
    },
    bodyWeight: {
      label: '體重',
      options: {
        underweight: '體重過輕',
        normalWeight: '正常體重',
        overweight: '超重',
        obese: '肥胖'
      }
    },
    faceShape: {
      label: '臉型',
      options: {
        oval: '橢圓形',
        round: '圓形',
        square: '方形',
        heartShaped: '心形',
        long: '長形',
        rectangle: '矩形',
        triangle: '三角形',
        invertedTriangle: '倒三角形',
        pearShaped: '梨形',
        oblong: '長橢圓形'
      }
    },
    facialFeatureDetails: {
      label: '面部特徵細節',
      options: {
        highNoseBridge: '高鼻樑',
        shortNose: '短鼻',
        largeEyes: '大眼睛',
        smallEyes: '小眼睛',
        highCheekbones: '高顴骨',
        smallMouth: '小嘴',
        fullLips: '豐滿嘴唇',
        perfectTeeth: '完美牙齒',
        squint: '瞇眼',
        naturalExpression: '自然表情'
      }
    },
    eyeFeatures: {
      label: '眼部特徵',
      options: {
        doubleEyelids: '雙眼皮',
        singleEyelids: '單眼皮',
        innerDoubleEyelids: '內雙',
        deepSetEyes: '深邃眼睛',
        bagsUnderEyes: '眼袋',
        eyeshadowEffect: '眼影效果',
        eyeliner: '眼線'
      }
    },
    ears: {
      label: '耳朵',
      options: {
        visibleEars: '可見耳朵',
        hiddenEars: '隱藏耳朵',
        largeEars: '大耳朵',
        smallEars: '小耳朵',
        piercedEars: '穿耳洞',
        earrings: '耳環'
      }
    },
    skinDetails: {
      label: '皮膚細節',
      options: {
        smoothSkin: '光滑皮膚',
        spottedSkin: '斑點皮膚',
        dullSkin: '暗沉皮膚',
        healthyGlow: '健康光澤',
        naturalSkinTone: '自然膚色',
        acneFreckles: '痘痘/雀斑',
        wrinklesAgedLook: '皺紋/老化外觀'
      }
    },
    skinTextureEffect: {
      label: '皮膚質感效果',
      options: {
        flawlessSkin: '無瑕皮膚',
        texturedSkin: '有質感皮膚',
        matteSkin: '啞光皮膚',
        glossySkin: '光澤皮膚',
        enhancedDetailTexture: '增強細節質感'
      }
    },
    clothingStyle: {
      label: '服裝風格',
      options: {
        formalWear: '正式服裝',
        suit: '西裝',
        businessAttire: '商務裝',
        eveningAttire: '晚禮服',
        casualWear: '休閒服裝',
        sportswear: '運動服裝',
        uniform: '制服',
        weddingAttire: '婚禮服',
        traditionalCostume: '傳統服裝',
        vintageRetroClothing: '復古/懷舊服裝'
      }
    },
    clothingTexture: {
      label: '服裝質感',
      options: {
        silkGlossyTexture: '絲綢/光澤質感',
        sweaterTexture: '毛衣質感',
        leatherTexture: '皮革質感',
        printedPattern: '印花圖案',
        denimTexture: '牛仔質感'
      }
    },
    headAccessories: {
      label: '頭部配飾',
      options: {
        hat: '帽子',
        glasses: '眼鏡',
        jewelry: '珠寶',
        hairAccessories: '髮飾',
        faceAccessories: '面部配飾'
      }
    }
  };
